import { render, staticRenderFns } from "./StallShareDialog.vue?vue&type=template&id=af195aac&scoped=true"
import script from "./StallShareDialog.vue?vue&type=script&lang=js"
export * from "./StallShareDialog.vue?vue&type=script&lang=js"
import style0 from "./StallShareDialog.vue?vue&type=style&index=0&id=af195aac&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "af195aac",
  null
  
)

export default component.exports